var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "131px",
    height: "102px",
    viewBox: "0 0 131 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-6---Users",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3---import-data---upload-file",
    transform: "translate(-694.000000, -305.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(694.000000, 305.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document",
    transform: "translate(11.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,55.2212389 C115,24.7239292 90.375125,0 60,0 C29.624875,0 5,24.7239292 5,55.2212389 C5,63.3470442 6.76275,71.0545487 9.9005,78 L110.0995,78 C113.23725,71.0545487 115,63.3470442 115,55.2212389",
    id: "Fill-1",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,78 L3,78",
    id: "Stroke-5",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,78 L119,78",
    id: "Stroke-7",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,78 L113,78",
    id: "Stroke-3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,87 C100,88.6571429 86.7914921,90 70.5,90 C54.2066349,90 41,88.6571429 41,87 C41,85.3428571 54.2066349,84 70.5,84 C86.7914921,84 100,85.3428571 100,87",
    id: "Fill-9",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,61 L106.992524,23.6648148 C106.992524,21.0888889 104.884329,19 102.282726,19 L38.707929,19 C36.1081953,19 34,21.0888889 34,23.6648148 L34.0074759,61 L107,61 Z",
    id: "Fill-11",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4548865,61 L86,19 L38.7255673,19 C36.1160937,19 34,21.0888889 34,23.6648148 L34.0075039,61 L43.4548865,61 Z",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,61 L107,70.3333333 C107,72.9111111 104.891589,75 102.28785,75 L38.7084112,75 C36.1084112,75 34,72.9111111 34,70.3333333 L34,61 L107,61 Z",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,61 L107,70.3333333 C107,72.9111111 104.891589,75 102.28785,75 L38.7084112,75 C36.1084112,75 34,72.9111111 34,70.3333333 L34,61 L107,61 Z",
    id: "Stroke-17",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,68.5 C73,69.8809524 71.8829365,71 70.5,71 C69.1190476,71 68,69.8809524 68,68.5 C68,67.1210317 69.1190476,66 70.5,66 C71.8829365,66 73,67.1210317 73,68.5",
    id: "Fill-19",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,68.5 C73,69.8809524 71.8829365,71 70.5,71 C69.1190476,71 68,69.8809524 68,68.5 C68,67.1210317 69.1190476,66 70.5,66 C71.8829365,66 73,67.1210317 73,68.5 Z",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFFFFF",
    points: "82 85 58 85 59.2 76 80.8 76"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-25",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "82 85 58 85 59.2 76 80.8 76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,85 L89,85",
    id: "Stroke-27",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,61 L106.992524,23.6648148 C106.992524,21.0888889 104.884329,19 102.282726,19 L38.707929,19 C36.1081953,19 34,21.0888889 34,23.6648148 L34.0074759,61 L107,61 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(107.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#7450C8",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53759483,8.27875851 L4.30957345,7.10032334 C4.12768497,6.8965068 3.84209296,6.80772722 3.57021604,6.87048554 C3.29833912,6.93324386 3.08606351,7.136948 3.02066444,7.39784682 C2.95526537,7.65874563 3.04778062,7.93280574 3.26017336,8.10734976 L5.00917351,9.79286914 C5.14962852,9.92655833 5.33976953,10.0010856 5.53759483,9.99998805 C5.7328427,9.99919912 5.91994812,9.924814 6.0585736,9.79286914 L9.77985051,6.2218535 C9.92074746,6.08775 10,5.90520264 10,5.71476927 C10,5.52433591 9.92074746,5.34178855 9.77985051,5.20768505 C9.48956303,4.93077165 9.02073789,4.93077165 8.73045042,5.20768505 L5.53759483,8.27875851 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(0.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#7450C8",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53759483,8.27875851 L4.30957345,7.10032334 C4.12768497,6.8965068 3.84209296,6.80772722 3.57021604,6.87048554 C3.29833912,6.93324386 3.08606351,7.136948 3.02066444,7.39784682 C2.95526537,7.65874563 3.04778062,7.93280574 3.26017336,8.10734976 L5.00917351,9.79286914 C5.14962852,9.92655833 5.33976953,10.0010856 5.53759483,9.99998805 C5.7328427,9.99919912 5.91994812,9.924814 6.0585736,9.79286914 L9.77985051,6.2218535 C9.92074746,6.08775 10,5.90520264 10,5.71476927 C10,5.52433591 9.92074746,5.34178855 9.77985051,5.20768505 C9.48956303,4.93077165 9.02073789,4.93077165 8.73045042,5.20768505 L5.53759483,8.27875851 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(14.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#7450C8",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53759483,8.27875851 L4.30957345,7.10032334 C4.12768497,6.8965068 3.84209296,6.80772722 3.57021604,6.87048554 C3.29833912,6.93324386 3.08606351,7.136948 3.02066444,7.39784682 C2.95526537,7.65874563 3.04778062,7.93280574 3.26017336,8.10734976 L5.00917351,9.79286914 C5.14962852,9.92655833 5.33976953,10.0010856 5.53759483,9.99998805 C5.7328427,9.99919912 5.91994812,9.924814 6.0585736,9.79286914 L9.77985051,6.2218535 C9.92074746,6.08775 10,5.90520264 10,5.71476927 C10,5.52433591 9.92074746,5.34178855 9.77985051,5.20768505 C9.48956303,4.93077165 9.02073789,4.93077165 8.73045042,5.20768505 L5.53759483,8.27875851 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6091136,45.9279643 C28.6091136,47.3561786 27.4544091,48.5154643 26.0294545,48.5154643 L2.57965909,48.5154643 C1.15470455,48.5154643 7.10542736e-15,47.3561786 7.10542736e-15,45.9279643 C7.10542736e-15,44.4986786 1.15470455,43.3404643 2.57965909,43.3404643 L26.0294545,43.3404643 C27.4544091,43.3404643 28.6091136,44.4986786 28.6091136,45.9279643",
    id: "Fill-31",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6091136,45.9279643 C28.6091136,47.3561786 27.4544091,48.5154643 26.0294545,48.5154643 L2.57965909,48.5154643 C1.15470455,48.5154643 7.10542736e-15,47.3561786 7.10542736e-15,45.9279643 C7.10542736e-15,44.4986786 1.15470455,43.3404643 2.57965909,43.3404643 L26.0294545,43.3404643 C27.4544091,43.3404643 28.6091136,44.4986786 28.6091136,45.9279643 Z",
    id: "Stroke-33",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7955455,43.3403571 L2.57965909,43.3403571 C1.15470455,43.3403571 -3.55271368e-14,44.4985714 -3.55271368e-14,45.9278571 C-3.55271368e-14,47.3571429 1.15470455,48.5153571 2.57965909,48.5153571 L19.7955455,48.5153571 L19.7955455,43.3403571 Z",
    id: "Fill-35",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7955455,43.3403571 L2.57965909,43.3403571 C1.15470455,43.3403571 -3.55271368e-14,44.4985714 -3.55271368e-14,45.9278571 C-3.55271368e-14,47.3571429 1.15470455,48.5153571 2.57965909,48.5153571 L19.7955455,48.5153571 L19.7955455,43.3403571 Z",
    id: "Stroke-39",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98331364,8.58642857 C5.49195,8.58642857 5.04331364,8.86714286 4.82647273,9.30964286 C4.60963182,9.75214286 4.66304091,10.2803571 4.96213182,10.6703571 L13.2832682,21.4896429 C13.5268136,21.8067857 13.90495,21.9932143 14.30445,21.9932143 C14.70395,21.9932143 15.0820864,21.8067857 15.3256318,21.4896429 L23.6457,10.6703571 C23.9458591,10.2803571 23.9992682,9.75214286 23.7824273,9.30964286 C23.5655864,8.86714286 23.11695,8.58642857 22.6245182,8.58642857 L19.4637682,8.58642857 L19.4637682,2.5875 C19.4637682,1.15821429 18.3090636,6.92779167e-14 16.8841091,6.92779167e-14 L11.7247909,6.92779167e-14 C10.2998364,6.92779167e-14 9.14513182,1.15821429 9.14513182,2.5875 L9.14513182,8.58642857 L5.98331364,8.58642857 Z",
    id: "Fill-41",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98331364,8.58642857 C5.49195,8.58642857 5.04331364,8.86714286 4.82647273,9.30964286 C4.60963182,9.75214286 4.66304091,10.2803571 4.96213182,10.6703571 L13.2832682,21.4896429 C13.5268136,21.8067857 13.90495,21.9932143 14.30445,21.9932143 C14.70395,21.9932143 15.0820864,21.8067857 15.3256318,21.4896429 L23.6457,10.6703571 C23.9458591,10.2803571 23.9992682,9.75214286 23.7824273,9.30964286 C23.5655864,8.86714286 23.11695,8.58642857 22.6245182,8.58642857 L19.4637682,8.58642857 L19.4637682,2.5875 C19.4637682,1.15821429 18.3090636,6.92779167e-14 16.8841091,6.92779167e-14 L11.7247909,6.92779167e-14 C10.2998364,6.92779167e-14 9.14513182,1.15821429 9.14513182,2.5875 L9.14513182,8.58642857 L5.98331364,8.58642857 Z",
    id: "Stroke-43",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.4080739715b106420d19b4f9eece8785.svg";
export { ForwardRef as ReactComponent };